export const TARGET_DATE = new Date('2025-06-15T00:00');

export const BOOK_A_DEMO_LINK =
  'https://meetings.hubspot.com/mharalson?uuid=df779104-51a2-43be-80fa-f8fc542c2ed7';

export const BOOK_A_SENSORS_DEMO_LINK = 'https://meetings.hubspot.com/mharalson/meet-about-sensors-with-michael-haralson'  

export const buildDemoLink = (params?: {
  sensorCategory?: string;
  sensor?: string;
}): string => {
  if (!params?.sensorCategory && !params?.sensor) return BOOK_A_SENSORS_DEMO_LINK;
  const searchParams = new URLSearchParams();
  if (params.sensorCategory) searchParams.set('sensor_category', params.sensorCategory);
  if (params.sensor) searchParams.set('sensor', params.sensor);
  const separator = BOOK_A_SENSORS_DEMO_LINK.includes('?') ? '&' : '?';
  return `${BOOK_A_SENSORS_DEMO_LINK}${separator}${searchParams.toString()}`;
};
